import axios from "@shared/axios";

async function getDashboardStats()
{
	const response = await axios.get(
		"/admin/dashboard/stats"
	);

	return response?.data ?? {};
}

async function getUnreadMessagesCount(): Promise<number>
{
	const response = await axios.get(
		"/admin/box/contact-messages/unread-count"
	);

	return response?.data ?? null;
}

async function getClaimedLostItemsCount(): Promise<number>
{
	const response = await axios.get(
		"/admin/dashboard/stats/claimed-lost-items-count"
	);

	return response?.data ?? 0;
}

export {
	getDashboardStats,
	getUnreadMessagesCount,
	getClaimedLostItemsCount
};
